import { useTranslation } from "react-i18next";
import LegalLayout from "./LegalLayout";

function FrContent() {
  const reset = () => {
    try {
      localStorage.removeItem("cartonomie_cookie_consent_v1");
      window.location.reload();
    } catch { /* ignore */ }
  };

  return (
    <>
      <section>
        <p className="text-slate-600">
          Cartonomie utilise un nombre <strong>minimal de cookies</strong>, dans le respect strict du
          RGPD et de la directive ePrivacy. Nous ne pratiquons ni publicité ciblée, ni profilage
          marketing, ni revente de données.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">1. Cookies strictement nécessaires</h2>
        <p>Ces cookies sont indispensables au fonctionnement du site et ne nécessitent pas votre consentement.</p>
        <div className="mt-3 overflow-x-auto">
          <table className="w-full text-xs border border-slate-200">
            <thead className="bg-slate-50">
              <tr>
                <th className="text-left p-2 border-b border-slate-200">Nom</th>
                <th className="text-left p-2 border-b border-slate-200">Finalité</th>
                <th className="text-left p-2 border-b border-slate-200">Durée</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-2 border-b border-slate-100 font-mono">access_token</td>
                <td className="p-2 border-b border-slate-100">Authentification utilisateur (JWT)</td>
                <td className="p-2 border-b border-slate-100">Session</td>
              </tr>
              <tr>
                <td className="p-2 border-b border-slate-100 font-mono">refresh_token</td>
                <td className="p-2 border-b border-slate-100">Renouvellement de session</td>
                <td className="p-2 border-b border-slate-100">30 jours</td>
              </tr>
              <tr>
                <td className="p-2 border-b border-slate-100 font-mono">cartonomie_lang</td>
                <td className="p-2 border-b border-slate-100">Langue d'affichage choisie</td>
                <td className="p-2 border-b border-slate-100">1 an</td>
              </tr>
              <tr>
                <td className="p-2 font-mono">cartonomie_currency</td>
                <td className="p-2">Devise d'affichage choisie</td>
                <td className="p-2">1 an</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">2. Cookies de mesure d'audience</h2>
        <p>
          Cartonomie utilise un <strong>dashboard d'analytique interne</strong> (statistiques agrégées par jour, IP hachée) qui ne dépose <strong>aucun cookie tiers</strong>. Aucune donnée n'est transmise à Google Analytics, Facebook, ou tout autre réseau publicitaire. Aucune publicité ciblée, aucun profilage marketing.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">3. Gérer vos préférences</h2>
        <p>
          Vous pouvez à tout moment réinitialiser vos choix de cookies ci-dessous, ou désactiver les
          cookies via les paramètres de votre navigateur.
        </p>
        <button
          onClick={reset}
          data-testid="cookie-reset-btn"
          className="mt-3 px-4 py-2 text-xs font-semibold rounded-xl bg-slate-900 text-white hover:bg-slate-800 transition"
        >
          Réinitialiser mes préférences cookies
        </button>
      </section>
    </>
  );
}

function EnContent() {
  const reset = () => {
    try {
      localStorage.removeItem("cartonomie_cookie_consent_v1");
      window.location.reload();
    } catch { /* ignore */ }
  };
  return (
    <>
      <section>
        <p className="text-slate-600">
          Cartonomie uses a <strong>minimal set of cookies</strong>, in strict compliance with GDPR
          and the ePrivacy Directive. No targeted advertising, no marketing profiling, no data resale.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Strictly necessary cookies</h2>
        <p>Authentication tokens, language and currency preferences. No consent required (Art. 82 French Data Protection Act).</p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Analytics (internal)</h2>
        <p>Privacy-friendly built-in analytics with no third-party cookie. No data leaves our database.</p>
      </section>
      <section>
        <button
          onClick={reset}
          data-testid="cookie-reset-btn"
          className="px-4 py-2 text-xs font-semibold rounded-xl bg-slate-900 text-white hover:bg-slate-800 transition"
        >
          Reset my cookie preferences
        </button>
      </section>
    </>
  );
}

export default function Cookies() {
  const { i18n } = useTranslation();
  const isFr = (i18n.language || "en").toLowerCase().startsWith("fr");
  return (
    <LegalLayout
      testId="cookies-page"
      title={isFr ? "Politique cookies" : "Cookie policy"}
      subtitle={isFr
        ? "Le détail des cookies utilisés par Cartonomie et comment les gérer."
        : "Details of cookies used by Cartonomie and how to manage them."}
      lastUpdated={isFr ? "Mise à jour · Février 2026" : "Updated · February 2026"}
    >
      {isFr ? <FrContent /> : <EnContent />}
    </LegalLayout>
  );
}
